import { render, staticRenderFns } from "./GlobalShiftsFilter.vue?vue&type=template&id=2f8f0ade&scoped=true"
import script from "./GlobalShiftsFilter.vue?vue&type=script&lang=js"
export * from "./GlobalShiftsFilter.vue?vue&type=script&lang=js"
import style0 from "./GlobalShiftsFilter.vue?vue&type=style&index=0&id=2f8f0ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f0ade",
  null
  
)

export default component.exports